export default "__VITE_PUBLIC_ASSET__8175e357__"